const config = {
  domain: import.meta.env.VITE_DOMAIN,
  apiURL: import.meta.env.VITE_API_URL,
  mode: import.meta.env.MODE,
  siteKey: import.meta.env.VITE_REACT_APP_SITE_KEY,
  wsURL: import.meta.env.VITE_WS_URL,
  offerTimeOutTime: import.meta.env.VITE_OFFER_TIMEOUT_TIME,
  offerIdlePromptTime: import.meta.env.VITE_OFFER_IDLE_PROMPT_TIME,
  externalURL: import.meta.env.VITE_EXTERNAL_URL,

  //Siemens ID
  siemensIdLoginUrl: import.meta.env.VITE_SIEMENS_ID_LOGIN_URL,
  siemensIdLoginClientId: import.meta.env.VITE_SIEMENS_ID_LOGIN_CLIENT_ID,
  siemensIdLoginRedirectUrl: import.meta.env.VITE_SIEMENS_ID_LOGIN_REDIRECT_URL,

  //Module Enable
  handoverFormEnabled: import.meta.env.VITE_HANDOVER_FORM_ENABLED === 'true',
  PREnabled: import.meta.env.VITE_PR_ENABLED === 'true',
  allowMaterialRFQ: import.meta.env.VITE_ALLOW_MATERIAL_RFQ === 'true',
}

export const APP_MODE = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
  PREPROD: 'preprod',
}

export default config
